<app-web-loader *ngIf="isLoader"></app-web-loader>

<div id="login-inner-container">
    <div class="login-logo-div" >
        <img src="assets/images/logo.png" alt="" />
    </div>
    <a href="javascript:;" (click)="OpenHelpModel()" class="help-icon">
        <i class="fa fa-question-circle"></i>
    </a>

    <div class="login-bottom-div">
        <div class="login-form-div" *ngIf="!isForgotPIN" style="margin-bottom: 60px;">
            <form autocomplete="off" method="post" (ngSubmit)="doUserLogin()" [formGroup]="userForm">
                <div class="form-group" style="margin-bottom: 10px;">
                    <label for="userName" class="login-lable">Enter Mobile No <span
                            style="color:#18aa87;">(Whatsapp)</span></label>
                    <input type="text" class="form-control" formControlName="userName" maxlength="10"
                        placeholder="10-digit Mobile Number without +91" style="text-align: center;"
                        autocomplete="off" />
                    <div *ngIf="userForm.get('userName').hasError('pattern')" style="color: red;">
                        Please enter a valid 10-digit number.
                    </div>
                </div>
                <div class="form-group" *ngIf="isOTP" style="margin-bottom: 10px;">
                    <label for="userotp" class="login-lable">Enter OTP</label>
                    <input type="text" placeholder="Enter OTP" class="form-control text-center" id="userotp"
                        [(ngModel)]="userotp" [ngModelOptions]="{standalone: true}" autocomplete="off" />
                </div>
                <div class="form-group" *ngIf="isPIN" style="margin-bottom: 10px;">
                    <label for="userotp" class="login-lable">Enter PIN</label>
                    <input type="text" placeholder="Enter PIN" class="form-control text-center" id="userPIN"
                        [(ngModel)]="userPIN" [ngModelOptions]="{standalone: true}" autocomplete="off" />
                </div>
                <div class="form-group" *ngIf="isLoginWithOtp">
                    <label for="userotp" class="login-lable">Enter OTP</label>
                    <input type="text" placeholder="Enter OTP" class="form-control text-center" id="userotp"
                        [(ngModel)]="userotp" [ngModelOptions]="{standalone: true}" autocomplete="off" />
                </div>

                <ng-container *ngIf="isOTP">
                    <div class="form-group" style="margin-bottom: 10px;">
                        <label for="userotp" class="login-lable">Enter Company Name</label>
                        <input type="text" class="form-control" id="companyName"
                            [(ngModel)]="addBuilderModel.CompanyName" [ngModelOptions]="{standalone: true}"
                            autocomplete="off" />
                    </div>
                    <div class="form-group" style="margin-bottom: 10px;">
                        <label class="w-100" for="userotp" style="width: 100%;" class="login-lable">
                            Areas Of Operation
                        </label>
                        <select [(ngModel)]="selectedCitiesList" id="ddlPreferredAreas"
                            [ngModelOptions]="{standalone: true}" class="form-control selectpicker"
                            data-selected-text-format="count" data-size="5" data-live-search="true">
                            <option style="width: 300px !important;" *ngFor="let area of areasList"
                                value="{{area.AreaID}}">{{ area.AreaName }}
                            </option>
                        </select>
                    </div>
                </ng-container>
                <div class="form-group" *ngIf="isUserPin" style="margin-bottom: 10px;">
                    <label for="userotp" class="login-lable" style="color: red;">Create PIN for Login</label>
                    <div class="otp-entry-div text-center">
                        <div class="form-group text-center">
                            <span *ngFor="let pinNum of enteredPin" class="span-otp-text">{{ pinNum }}</span>
                        </div>
                    </div>
                    <div class="otp-keypad-div" style="margin-bottom: 10px;">
                        <div class="otp-keypad-inner-div">
                            <span class="span-keypad-text" (click)="AddPINintoArray('1')">1</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('2')">2</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('3')">3</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('B')">
                                <i class="fa fa-backspace"></i>
                            </span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('4')">4</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('5')">5</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('6')">6</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('C')">C</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('7')">7</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('8')">8</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('9')">9</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('0')">0</span>
                        </div>
                    </div>
                </div>
                <div class="form-group login-buttons-div">
                    <input type="submit" class="btn btn-login w-100 mt-2 mb-2" value="Continue" />

                    <!-- Resend OTP button as a button -->
                    <div *ngIf="isOTP">
                        <input type="button" *ngIf="isOTP" (click)="SendOTPSMS(true)"
                            style="width: 150px; margin: 0px auto;" class="btn btn-link" value="Resend OTP" />
                    </div>
                    <div *ngIf="isOTP == false">
                        <button type="button" *ngIf="isOTP == false ? isPIN : isOTP" class="btn btn-link w-45"
                            (click)="ForgotPassword()">Forgot PIN</button>
                        <button type="button" *ngIf="isOTP == false ? isPIN : isOTP"
                            class="btn btn-link w-45 font-weight-bold w-100" (click)="doLoginWithOTP()">Login With
                            OTP</button>
                        <button type="button" *ngIf="isLoginWithOtp" style="margin-top: 10px;"
                            class="btn btn-link w-45" (click)="doLoginWithOTP()" [disabled]="isButtonClicked">Resend
                            OTP</button>
                        <button type="button" *ngIf="isLoginWithOtp" style="margin-top: 10px;"
                            class="btn btn-link w-45" (click)="ResetToLogin()">Clear All</button>
                        <!-- Spacer -->
                    </div>
                    <div style="margin-bottom: 10px;"></div>

                    <!-- Watch Help Video button with modal trigger -->
                    <a href="javascript:;" (click)="OpenHelpModel()" class="btn btn-watch-video">
                        <i class="fab fa-youtube"></i> Watch Help Video
                    </a>
                </div>
            </form>
        </div>

        <div class="login-form-div" *ngIf="isForgotPIN" style="margin-bottom: 60px;">
            <form autocomplete="off" method="post" (ngSubmit)="doChangeUserPassword()">
                <div class="form-group" style="margin-bottom: 10px;">
                    <label for="userName" class="login-lable">Enter Mobile No <span
                            style="color:#00d561;">(Whatsapp)</span></label>
                    <input type="text" [disabled]="isForgotPIN" class="form-control" id="userName"
                        [(ngModel)]="userName" [ngModelOptions]="{standalone: true}"
                        placeholder="India (+91) Your Phone Number" style="text-align: center;"
                        autocomplete="off" />
                </div>
                <div class="form-group" style="margin-bottom: 10px;">
                    <label for="userotp" class="login-lable">Enter OTP</label>
                    <input type="text" placeholder="Enter OTP" class="form-control text-center" id="userotp"
                        [(ngModel)]="userotp" [ngModelOptions]="{standalone: true}" autocomplete="off" />
                </div>

                <div class="form-group" *ngIf="isUserPin" style="margin-bottom: 10px;">
                    <label for="userotp" class="login-lable">Setup PIN for BuyRentSale Login</label>
                    <div class="otp-entry-div text-center">
                        <div class="form-group text-center">
                            <span *ngFor="let pinNum of enteredPin" class="span-otp-text">{{ pinNum }}</span>
                        </div>
                    </div>
                    <div class="otp-keypad-div" style="margin-bottom: 10px;">
                        <div class="otp-keypad-inner-div">
                            <span class="span-keypad-text" (click)="AddPINintoArray('1')">1</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('2')">2</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('3')">3</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('B')">
                                <i class="fa fa-backspace"></i>
                            </span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('4')">4</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('5')">5</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('6')">6</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('C')">C</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('7')">7</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('8')">8</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('9')">9</span>
                            <span class="span-keypad-text" (click)="AddPINintoArray('0')">0</span>
                        </div>
                    </div>
                </div>
                <input type="submit" class="btn btn-login w-100" value="Continue" style="margin-bottom: 10px;" />
                <!-- Resend OTP button as a button -->
                <button type="button" *ngIf="!isUserPin" style="margin-top: 10px;" class="btn btn-link w-45"
                    (click)="ForgotPassword()">Resend OTP</button>

                <!-- Go To Login button as a button -->
                <button type="button" *ngIf="!isUserPin" class="btn btn-link w-45" (click)="ResetToLogin()">Go To
                    Login</button>
            </form>

        </div>

    </div>
</div>

<div class="modal fade" id="UserAlreadyExitsModal" tabindex="-1" role="dialog"
    aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
            <div class="confirm-user-div">
                <h5 class="text-center" *ngIf="UserData.length !== 0">
                    With this number, an account already exists as
                    <span *ngIf="UserData[0].IsVisitorActive" [ngStyle]="{'color': 'blue'}">
                        Visitor<span
                            *ngIf="UserData[0].IsAgentActive || UserData[0].IsBuilderActive || UserData[0].IsBusinessActive">,</span>
                    </span>
                    <span *ngIf="UserData[0].IsAgentActive" [ngStyle]="{'color': 'green'}">
                        Agent<span *ngIf="UserData[0].IsBuilderActive || UserData[0].IsBusinessActive">,</span>
                    </span>
                    <span *ngIf="UserData[0].IsBuilderActive" [ngStyle]="{'color': 'orange'}">
                        Builder<span *ngIf="UserData[0].IsBusinessActive">,</span>
                    </span>
                    <span *ngIf="UserData[0].IsBusinessActive" [ngStyle]="{'color': 'purple'}">Service | Supplier</span>.
                </h5>

                <h6 class="text-center">
                    Do you want to continue as
                    <span style="color: red;">Service Provider | Supplier</span>?
                </h6>

                <div class="form-group text-center">
                    <input type="button" style="margin-right: 10px;" class="btn btn-danger" value="No"
                        (click)="doGotoLandingPage()" />
                    <input type="button" class="btn btn-success" value="Yes" (click)="SendOTPByMobile()" />
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="ConfirmModal" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content" style="padding: 20px;">
            <h3>The entered mobile number is not registered. Do you want to create new account ?</h3>
            <br />
            <div class="row">
                <div class="col-6">
                    <button (click)="doGotoLandingPage()" class="btn btn-danger pull-right">No</button>
                </div>
                <div class="col-6">
                    <input type="button" class="btn btn-success" value="Yes" (click)="SendOTPByMobile()"
                        [disabled]="isButtonClicked" />
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Modal Popup for Help -->
<div class="modal fade" id="helpModal" tabindex="-1" role="dialog" aria-labelledby="helpModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="helpModalLabel">Help and Support</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <!-- Add your support information here -->
                <p>For assistance, please contact:</p>
                <p class="contact">Email: <strong>support&#64;buyrentsale.com</strong></p>
                <p class="contact">Phone: <strong>91-9618641100</strong></p>

                <!-- Add a sample YouTube video link -->
                <p>For video assistance, you can watch this tutorial:</p>
                <iframe width="100%" height="315" src="https://www.youtube.com/embed/ynnCXJTpklk?si=UflK7z3suTzCwXsS"
                    title="YouTube video player" frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>